import React, { useRef} from 'react';
import { Controller } from 'react-hook-form';
import {
    FormError,
    FormLabel,
    getInputClassNames,
    getWholeDivWrapperClass,
} from "./sharedStyles.tsx";
import {FormComponentProps, TextAreaComponent} from '../DynamicFormTypes.ts';
import {ValidationFactory} from "../ValidationFactory.ts";
import { useFormMethods} from "../DyanmicFormContext.tsx";
import {useFieldBlurHandler} from "../hooks/OnFieldBlurHanlder.tsx";
import {useValidationRules} from "../hooks/useValidationRules.tsx";

const TextAreaRenderer: React.FC<FormComponentProps<TextAreaComponent>> = ({ component }) => {
    // Build validation rules
    const { formMethods } = useFormMethods()
    const validate = useValidationRules({ component });
    // Reference to the textarea element for auto-expanding feature
    const textareaRef = useRef<HTMLTextAreaElement | null>(null);

    const { handleFieldBlur } = useFieldBlurHandler({
        component
        // That's it! The hook handles setting form values automatically
    });


    const max = ValidationFactory.getMaxValue(component, undefined);

    return (
        <Controller
            name={component.fieldKey}
            control={formMethods.control}
            rules={validate}
            render={({ field: { ref, onBlur, ...fieldProps }, fieldState }) => {
                // Get base classes and adjust padding for textarea using reactive fieldState
                const baseClasses = getInputClassNames(component, fieldState);
                // Replace py-2.5 with py-3 for more comfortable text area editing
                const textareaClasses = baseClasses.replace('py-2.5', 'py-3');

                return (
                    <div className={getWholeDivWrapperClass(component)}>
                        <FormLabel component={component} />

                        <textarea
                            id={component.fieldKey}
                            ref={textareaRef}
                            rows={4}
                            maxLength={max}
                            className={textareaClasses}
                            placeholder={component.placeHolder ? component.placeHolder : `${max ? "Max: " + max + " characters" : ""}`}
                            onBlur={(_e) => {
                                onBlur()
                                handleFieldBlur()
                            }}
                            {...fieldProps}
                        />

                        <FormError fieldState={fieldState} component={component} />
                    </div>
                );
            }}
        />
    );
};

export const TextArea = React.memo(TextAreaRenderer);